import styles from "./tabTransfer.module.scss";
import TransferKepad from "../transferKeypad/dialpadNumber";

function TabTransfer() {
  return (
    <>
      <div className={`${styles.callcontainartopsec} `}>
        <TransferKepad />
      </div>
    </>
  );
}
export default TabTransfer;
